
import React from 'react';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box'; // Import Box for the logo container
import { mainSidebarItems } from './const/sidebarItems';
import { sidebarStyles } from '../styles';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (route) => {
    if (route === "/portfolio") {
      return location.pathname.startsWith("/portfolio") || 
             location.pathname.startsWith("/company");
    }
    if (route === "/activity-reports") {
      return location.pathname.startsWith("/activity-reports") || 
             location.pathname.startsWith("/grade-reports") || location.pathname.startsWith("/create-request");
    }
    return location.pathname.startsWith(route);
  };
  return (
    <Drawer
      sx={sidebarStyles.drawer}
      variant="permanent"
      anchor="left"
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <Box
          component="img"
          src="/Logo.png"
          alt="Bessemer Venture Partners"
          sx={{ width: "100%" }}
        />
      </Toolbar>
      <Divider />
      <List>
        {mainSidebarItems.map((item, index) => (
          <ListItem key={item.id} disablePadding onClick={() => navigate(item.route)}>
            <ListItemButton
              sx={{
                margin: '8px 8px 8px 15px',
                padding: '0',
                ...(isActive(item.route) && {
                  backgroundColor: '#fff',
                  borderRadius: '20px',
                  border: '2px solid #E0E3E5',
                  color: '#1A1919',
                  '& .MuiListItemIcon-root': {
                    color: '#005786',
                  },
                }),
                '&:hover': {
                  backgroundColor: '#fff', // Custom hover background color
                  borderRadius: '20px', // Custom hover border radius
                  border: '2px solid #E0E3E5',
                  color: '#1A1919', // Custom hover text color
                  '& .MuiListItemIcon-root': {
                    color: '#005786', // Custom hover icon color
                  },
                },
              }}
            >
              <ListItemIcon sx={sidebarStyles.icons}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.label} sx={sidebarStyles.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  )
}

export default Sidebar